var map = {
	"./APRILYOS/logo_white_red.png": "Tayr",
	"./LNI/logo_white_red.png": "Huuc"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Mbjv";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*\/logo_white_red\.png$
// module id = Mbjv
// module chunks = 0